"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleExclusiveRegistrationNumberValidation = void 0;
var FalconValidationMethodBase_1 = require("./FalconValidationMethodBase");
/**
 * Validates exclusive cases (Q registration numbers and diplomat numbers) of vehicle registration numbers
 */
var VehicleExclusiveRegistrationNumberValidation = /** @class */ (function (_super) {
    __extends(VehicleExclusiveRegistrationNumberValidation, _super);
    function VehicleExclusiveRegistrationNumberValidation(props, commandsExecutor) {
        return _super.call(this, commandsExecutor) || this;
    }
    VehicleExclusiveRegistrationNumberValidation.prototype.validateInput = function (input, context) {
        if (context && context.interaction && context.interaction.vehicles && input) {
            if (input.match("(^Q[a-zA-Z0-9]{6,}$)|(^[0-9]{3,}[X|D][0-9]{3,}$)")) {
                return this.invalidResult(this.getErrorMessage(context, "Sorry we are unable to insure this vehicle"));
            }
        }
        return this.validResult();
    };
    return VehicleExclusiveRegistrationNumberValidation;
}(FalconValidationMethodBase_1.FalconValidationMethodBase));
exports.VehicleExclusiveRegistrationNumberValidation = VehicleExclusiveRegistrationNumberValidation;
//# sourceMappingURL=VehicleExclusiveRegistrationNumberValidation.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-services/dist/validations/VehicleExclusiveRegistrationNumberValidation.js
// module id = 2538
// module chunks = 0